const PAGES = {
  LANDING: "LANDING",
  FORM: "FORM",
  ONE_TIME_CODE: "ONE_TIME_CODE",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};
const EVENTS = {
  FAILED_TO_LOAD_ACCOUNT_OPTIONS: "FAILED_TO_LOAD_ACCOUNT_OPTIONS",
  NO_ACCOUNTS: "NO_ACCOUNTS",
  ACCOUNT_SELECTED: "ACCOUNT_SELECTED",
  BILLER_VERIFIED_SUCCESSFULLY: "BILLER_VERIFIED_SUCCESSFULLY",
  DETAILS_VERIFIED_SUCCESSFULLY: "DETAILS_VERIFIED_SUCCESSFULLY",
  DETAILS_VERIFICATION_FAILED: "DETAILS_VERIFICATION_FAILED",
  INVALID_RESPONSE: "INVALID_RESPONSE",
  BACK_CLICKED: "BACK_CLICKED",
  ONE_TIME_CODE_VERIFIED_SUCCESSFULLY: "ONE_TIME_CODE_VERIFIED_SUCCESSFULLY",
  ONE_TIME_CODE_VERIFICATION_FAILED: "ONE_TIME_CODE_VERIFICATION_FAILED",
};
const initialBpayState = {
  page: PAGES.LANDING,
  fromAccount: null,
  biller: {
    code: "",
    name: null,
  },
  referenceNumber: "",
  amount: "",
  paymentDate: null,
  errorType: null,
  maskedMobileNumber: null,
  verifyOtpAction: null,
  resendOtpAction: null,
  receiptNumber: null,
};

function bpayReducer(state, action) {
  switch (state.page) {
    case PAGES.LANDING: {
      switch (action.type) {
        case EVENTS.FAILED_TO_LOAD_ACCOUNT_OPTIONS: {
          return {
            ...state,
            page: PAGES.ERROR,
          };
        }

        case EVENTS.NO_ACCOUNTS: {
          return {
            ...state,
            page: PAGES.ERROR,
          };
        }

        case EVENTS.ACCOUNT_SELECTED: {
          return {
            ...state,
            fromAccount: action.fromAccount,
          };
        }

        case EVENTS.BILLER_VERIFIED_SUCCESSFULLY: {
          return {
            ...state,
            page: PAGES.FORM,
            biller: {
              code: action.biller.code,
              name: action.biller.name,
            },
            ...(action.biller.code !== state.biller.code && {
              referenceNumber: "",
            }),
          };
        }

        default: {
          return state;
        }
      }
    }

    case PAGES.FORM: {
      switch (action.type) {
        case EVENTS.DETAILS_VERIFIED_SUCCESSFULLY: {
          return {
            ...state,
            page: PAGES.ONE_TIME_CODE,
            referenceNumber: action.referenceNumber,
            amount: action.amount,
            paymentDate: action.paymentDate,
            maskedMobileNumber: action.maskedMobileNumber,
            verifyOtpAction: action.verifyOtpAction,
            resendOtpAction: action.resendOtpAction,
          };
        }

        case EVENTS.DETAILS_VERIFICATION_FAILED: {
          return {
            ...state,
            page: PAGES.ERROR,
            errorType: action.errorType,
          };
        }

        case EVENTS.INVALID_RESPONSE: {
          return {
            ...state,
            page: PAGES.ERROR,
          };
        }

        case EVENTS.BACK_CLICKED: {
          return {
            ...state,
            page: PAGES.LANDING,
            referenceNumber: action.referenceNumber,
            amount: action.amount,
          };
        }

        default: {
          return state;
        }
      }
    }

    case PAGES.ONE_TIME_CODE: {
      switch (action.type) {
        case EVENTS.ONE_TIME_CODE_VERIFIED_SUCCESSFULLY: {
          return {
            ...state,
            page: PAGES.SUCCESS,
            receiptNumber: action.receiptNumber,
          };
        }

        case EVENTS.ONE_TIME_CODE_VERIFICATION_FAILED: {
          return {
            ...state,
            page: PAGES.ERROR,
          };
        }

        case EVENTS.BACK_CLICKED: {
          return {
            ...state,
            page: PAGES.FORM,
          };
        }

        default: {
          return state;
        }
      }
    }

    default: {
      return state;
    }
  }
}

export { PAGES, EVENTS, initialBpayState, bpayReducer };
